<template>
	<Modal title="Liabilities Details" modal-width="full-width">
		<DisabledForm />

		<fieldset class="dt-responsive table-responsive">
			<legend>
				Liabilities: (List all loans, Credits, Unpaid bills and other
				liabilities)
			</legend>

			<Alert />

			<table id="dt-live-domd" class="table table-bordered nowrap">
				<thead>
					<tr>
						<th>Type of Liability</th>
						<th>Creditor</th>
						<th>Value</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="Object.keys(liabilities).length">
						<tr v-for="liability in liabilities" :key="'lb_' + liability.id">
							<td style="padding: 0.75rem 0.75rem">
								{{ liability.liability_type }}
							</td>
							<td style="padding: 0.75rem 0.75rem">
								{{ liability.name }}
							</td>
							<td style="padding: 0.75rem 0.75rem">
								{{ liability.value }}
							</td>
							<td style="padding: 0">
								<button
									@click="deleteItem(liability)"
									class="btn btn-danger"
									style="border-radius: 0; height: 47px; width: 100%"
									:disable="isLoading"
								>
									<span
										v-if="isLoading"
										class="spinner-border spinner-border-sm"
										role="status"
									></span>
									<span v-else>Delete</span>
								</button>
							</td>
						</tr>
					</template>
					<tr>
						<td>
							<input
								v-model="form.type_of_liability"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start typing..."
							/>
						</td>
						<td>
							<input
								v-model="form.creditor"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start typing..."
							/>
						</td>
						<td>
							<input
								v-model="form.value"
								type="text"
								class="form-control"
								autofocus
								placeholder="Start typing..."
							/>
						</td>

						<td>
							<button
								@click="saveRecord()"
								class="btn btn-info"
								style="border-radius: 0; width: 100%"
								:disable="isLoading"
							>
								<span
									v-if="isLoading"
									class="spinner-border spinner-border-sm"
									role="status"
								></span>
								<span v-else>Save</span>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</fieldset>
	</Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { EventBus } from "@/utils/event_bus.js";
import Alert from "@/components/Alert.vue";
import { mapGetters, mapActions } from "vuex";
import DisabledForm from "./DisabledForm.vue";
import Swal from "sweetalert2";

export default {
	components: {
		DisabledForm,
		Modal,
		Alert,
	},
	data() {
		return {
			approval_document_file_name: "",
			form: {
				report_id: this.$route.params.formID,
				report_type: "liabilities",
				report_from: "",
				report_to: "",
				approval_document: "",
				approved_by: "",
				type_of_liability: "",
				creditor: "",
				value: "",
			},
		};
	},
	computed: {
		...mapGetters({
			isLoading: "shared/getLoading",
			liabilities: "form_ec16c/liabilities",
		}),
	},
	methods: {
		...mapActions({
			addForm: "form_ec16c/addForm",
			deleteFormRecord: "form_ec16c/deleteFormRecord",
			getFormDetails: "form_ec16c/getFormDetails",
		}),

		async saveRecord() {
			await this.addForm(this.form).then((res) => {
				if (res.status_code == 201) {
					this.clearFormInput();
				}
			});
		},

		clearFormInput() {
			this.form.type_of_liability = "";
			this.form.creditor = "";
			this.form.value = "";
		},

		getFormItems() {
			let payload = {
				type: this.form.report_type,
				formID: this.$route.params.formID,
			};

			this.getFormDetails(payload);
		},

		deleteItem(item) {
			Swal.fire({
				title: "Delete Record?",
				text: "This action cannot be undone!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#29623c",
				confirmButtonText: "Yes, delete!",
				cancelButtonText: "Cancel",
			}).then((result) => {
				if (result.isConfirmed) {
					this.sendDeleteRequest(item);
				}
			});
		},

		async sendDeleteRequest(item) {
			let payload = {
				report_id: item.party_annual_report_id,
				item_id: item.id,
				report_type: item.report_type,
			};
			await this.deleteFormRecord(payload).then((res) => {
				if (res.status_code == 200) {
					Swal.fire("Deleted!", res.data.message, "success");
				}
			});
		},
	},
	mounted() {
		this.getFormItems();
		EventBus.$on("date-input", this.setDateInput);
		EventBus.$emit("toggle-modal", "show");
	},
};
</script>

<style scoped>
legend {
	background-color: #29623c;
	color: white;
	padding: 5px 10px;
}
.break-text {
	word-wrap: break-word;
	overflow-wrap: break-word;
	white-space: normal;
	padding: 0;
	padding-left: 2px;
	padding-top: 20px;
}
table {
	width: 100%;
	border-collapse: collapse;
}
td {
	height: 50px;
	padding: 0;
}
td > input {
	width: 100%;
	box-sizing: border-box;
	border: none;
	border-radius: 0;
	height: 100%;
}
.swal2-container {
	z-index: 1090 !important;
}

.modal {
	z-index: 1059 !important;
}
</style>
